<div>
  <div class="progress-label">{{label}}</div>
  @if (showRow()) {
    <div><strong>{{getFormattedPercent()}}%</strong></div>
  }
  @if (showRow()) {
    <div class="progress-bar">
      <mat-progress-bar [attr.aria-label]="label + 'Progress Bar'" id="{{getBarId()}}" mode="determinate" value="{{getProgressValue()}}" />
    </div>
  }
  @if (!showRow()) {
    <div>&nbsp;</div>
  }
  @if (!showRow()) {
    <div class="progress-bar">
      &nbsp;
    </div>
  }
</div>
